import { parseNumberStrict } from 'shouldve-been-js';

export function datetimeFromApiParser(datetimeString: string | null): Date | null {

    if (datetimeString === null) {
        return null;
    }

    try {
        const [datePart, timePart] = datetimeString.substring(0, 19).split('T');
        const [year, month, day] = datePart?.split('-') ?? [];

        const dayNum: number | null = parseNumberStrict(day ?? null);
        const monthNumRaw: number | null = parseNumberStrict(month ?? null);
        const monthNum: number | null = monthNumRaw === null ? null : monthNumRaw - 1;
        const yearNum: number | null = parseNumberStrict(year ?? null);

        if (dayNum === null || monthNum === null || yearNum === null) {
            return null;
        }

        if (timePart !== undefined) {
            const [hour, minute, second] = timePart.split(':');

            const hourNum: number | null = parseNumberStrict(hour ?? null);
            const minuteNum: number | null = parseNumberStrict(minute ?? null);
            const secondNum: number | null = parseNumberStrict(second ?? null);

            if (hourNum === null || minuteNum === null || secondNum === null) {
                return null;
            }

            return new Date(Date.UTC(yearNum, monthNum, dayNum, hourNum, minuteNum, secondNum));
        }

        return new Date(Date.UTC(yearNum, monthNum, dayNum));

    } catch (e: unknown) {
        return null;
    }
}

export function datetimeStandardParser(datetimeString: string | null, timezoneOffsetMinutes: number): Date | null {

    if (datetimeString === null) {
        return null;
    }

    try {
        const [datePart, timePart] = datetimeString.split('T');
        const [year, month, day] = datePart?.split('-') ?? [];

        const dayNum: number | null = parseNumberStrict(day ?? null);
        const monthNumRaw: number | null = parseNumberStrict(month ?? null);
        const monthNum: number | null = monthNumRaw === null ? null : monthNumRaw - 1;
        const yearNum: number | null = parseNumberStrict(year ?? null);

        if (dayNum === null || monthNum === null || yearNum === null) {
            return null;
        }

        if (timePart !== undefined) {
            const [hour, minute, second] = timePart.split(':');

            const hourNum: number | null = parseNumberStrict(hour ?? null);
            const minuteNum: number | null = parseNumberStrict(minute ?? null);
            const secondNum: number | null = parseNumberStrict(second ?? null);

            if (hourNum === null || minuteNum === null || secondNum === null) {
                return null;
            }

            const beforeTimezoneOffset: Date = new Date(Date.UTC(yearNum, monthNum, dayNum, hourNum, minuteNum, secondNum));

            return new Date(beforeTimezoneOffset.getTime() - timezoneOffsetMinutes * 60000);
        } else {

            return new Date(Date.UTC(yearNum, monthNum, dayNum)); //adjusting for the timezone offset makes very little sense in this case
        }


    } catch (e: unknown) {
        return null;
    }
}

export function datetimeToApiString(datetime: Date, timezoneOffsetMinutes: number): string {

    const localTimeRepresentation: Date = new Date(datetime.getTime() + timezoneOffsetMinutes * 60000);

    return localTimeRepresentation.getUTCFullYear().toString() + '-' + (localTimeRepresentation.getUTCMonth() + 1).toString().padStart(2, '0') + '-' + 
        localTimeRepresentation.getUTCDate().toString().padStart(2, '0') + 'T' + localTimeRepresentation.getUTCHours().toString().padStart(2, '0') + ':' + 
        localTimeRepresentation.getUTCMinutes().toString().padStart(2, '0') + ':' + localTimeRepresentation.getUTCSeconds().toString().padStart(2, '0');
}

export function datetimeToVisualString(datetime: Date | null, dateOnly: boolean, timezoneOffsetMinutes: number): string { //if you dont want the date to change due to timezone when dateOnly=true, just pass a timezone of 0 instead of the actual timezone

    if (datetime === null) {
        return '';
    }

    const localTimeRepresentation: Date = new Date(datetime.getTime() + timezoneOffsetMinutes * 60000);

    if (dateOnly) {
        return localTimeRepresentation.getUTCDate().toString().padStart(2, '0') + '.' + (localTimeRepresentation.getUTCMonth() + 1).toString().padStart(2, '0') + '.' + 
            localTimeRepresentation.getUTCFullYear().toString();
    } else {
        return localTimeRepresentation.getUTCDate().toString().padStart(2, '0') + '.' + (localTimeRepresentation.getUTCMonth() + 1).toString().padStart(2, '0') + '.' + 
            localTimeRepresentation.getUTCFullYear().toString() + ' ' + localTimeRepresentation.getUTCHours().toString().padStart(2, '0') + ':' + 
            localTimeRepresentation.getUTCMinutes().toString().padStart(2, '0') + ':' + localTimeRepresentation.getUTCSeconds().toString().padStart(2, '0');
    }
}